import React, { forwardRef, useImperativeHandle } from 'react';
import * as rsuite from 'rsuite';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


const Drp_POS = forwardRef((props, ref) => {

    const toaster = rsuite.useToaster();

    const [List, setList] = React.useState([]);
    const [Id, setId] = React.useState(General.GuidEmpty());
    const POS_Onchange = (value) => {
        props.onChange(value == null ? General.GuidEmpty() : value, value == null ? "" : List.find(x => x.Id == value).Title)
        setId(value)
    }
    useImperativeHandle(ref, () => ({

        Bind(id) {
            var isDefault = 0;
            var RequestOptions = {
                data: {
                    "BankAccountId": General.GuidEmpty(),
                    "IsActive": 1,
                },
                url: General.ApiRoute() + "/POS/Search",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }


            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        var temp = [];
                        for (let index = 0; index < result.data.length; index++) {
                            temp.push({
                                Id: result.data[index].id,
                                Title: result.data[index].bankAccount + " - " + result.data[index].title + " [" + result.data[index].code + "]",
                            })
                            if ((result.data[index].isDefault == 1 && id == General.GuidEmpty()) || result.data[index].id == id) {
                                props.onChange(result.data[index].id, result.data[index].bankAccount + " - " + result.data[index].title + " [" + result.data[index].code + "]")
                                isDefault = 1;
                                setId(result.data[index].id);

                            }
                            else if (isDefault == 0)
                                setId(id);
                        }
                        setList(temp);

                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )


        },
        // GetIsDefault() {
        //     var RequestOptions = {
        //         data: {
        //             "BankAccountId": General.GuidEmpty(),
        //             "IsActive": 1,
        //         },
        //         url: General.ApiRoute() + "/POS/Search",
        //         method: "post",
        //         withCredentials: true,
        //         headers: {
        //             'ApiKey': General.APIKey(),
        //             'Content-Type': 'application/json'
        //         }
        //     }
        //     trackPromise(
        //         axios(RequestOptions)
        //             .then(function (result) {
        //                 var temp = [];
        //                 for (let index = 0; index < result.data.length; index++) {
        //                     if (result.data[index].isDefault == 1) {
        //                         props.onSubmit(result.data[index].id, result.data[index].bankAccount + " - " + result.data[index].title + " [" + result.data[index].code + "]")
        //                     }
        //                 }

        //             }).catch((error) => {
        //                 toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

        //             })
        //     )


        // },

    }))



    return (
        <rsuite.SelectPicker


            data={List}
            valueKey="Id"
            labelKey="Title"
            className='w-100p'
            placeholder="انتخاب کنید..."
            value={Id}
            onChange={(value) => POS_Onchange(value)}

        />


    )
});

export default Drp_POS;